import { render } from "./DeliveryDetails.vue?vue&type=template&id=72aab3a8"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"
script.render = render

export default script